// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1KhKx","amount":"Amount_amount__14XGt","tip":"Amount_tip__r6Rnv","tipHeader":"Amount_tipHeader__1EAuI","tipsWrap":"Amount_tipsWrap__3d8Ca"};